import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: "0 24px",
        background: "#f5f5f5",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "56px 64px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
          background: "#fff",
          maxWidth: 500,
          width: "100%",
        }}
      >
        <div style={{ fontSize: 96, fontWeight: 700, color: "#222", lineHeight: 1 }}>
          404
        </div>
        <div style={{ fontSize: 18, fontWeight: 600, color: "#333", marginTop: 20 }}>
          Page Not Found
        </div>
        <p style={{ fontSize: 14, color: "#888", marginTop: 10, lineHeight: 1.7 }}>
          The page you are looking for does not exist or has been moved. Please check the URL or go back to the dashboard.
        </p>
        <Button
          type="primary"
          size="large"
          style={{ marginTop: 28, borderRadius: 8, paddingLeft: 32, paddingRight: 32 }}
          onClick={() => navigate("/dashboard")}
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
